import * as t from "react";
function s(e) {
  const [c, o] = t.useState(e);
  return t.useEffect(() => {
    const u = setTimeout(
      () => {
        o(e);
      },
      e.length ? 0 : 10
    );
    return () => {
      clearTimeout(u);
    };
  }, [e]), c;
}
export {
  s as default
};
//# sourceMappingURL=useDebounce.mjs.map
